"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledIconList = _styledComponents["default"].div.withConfig({
  componentId: "sc-1l961fz-0"
})(["display:inline-flex;align-items:center;"]);

var HalfIconContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1l961fz-1"
})(["width:fit-content;height:fit-content;position:relative;display:inline-flex;align-items:center;"]);

var IconEmpty = (0, _styledComponents["default"])(_pclnDesignSystem.Icon).withConfig({
  componentId: "sc-1l961fz-2"
})(["opacity:0.4;"]);
var IconHalf = (0, _styledComponents["default"])(_pclnDesignSystem.Icon).withConfig({
  componentId: "sc-1l961fz-3"
})(["position:absolute;top:0;right:0;left:0;bottom:0;"]);
var IconList = (0, _react.memo)(function (_ref) {
  var iconFull = _ref.iconFull,
      iconHalf = _ref.iconHalf,
      iconEmpty = _ref.iconEmpty,
      value = _ref.value,
      valueMax = _ref.valueMax,
      color = _ref.color,
      size = _ref.size;
  var icons = [];
  value = Math.round(value * 2) / 2;
  var index = 0;

  for (index; index < Math.floor(value) && index < valueMax; index++) {
    icons.push(_react["default"].createElement(_pclnDesignSystem.Icon, {
      className: "ppn-iconFull",
      title: "Star",
      key: index,
      name: iconFull,
      color: color,
      size: size
    }));
  }

  if (value % 0.5 === 0 && value % 1 !== 0) {
    index++;
    icons.push(_react["default"].createElement(HalfIconContainer, {
      key: index + 0.5
    }, _react["default"].createElement(IconEmpty, {
      className: "ppn-iconEmpty",
      title: "Half Star",
      name: iconEmpty,
      color: color,
      size: size
    }), _react["default"].createElement(IconHalf, {
      className: "ppn-iconHalf",
      title: "Half Star",
      name: iconHalf,
      color: color,
      size: size
    })));
  }

  for (index; index < valueMax; index++) {
    icons.push(_react["default"].createElement(IconEmpty, {
      className: "ppn-iconEmpty",
      title: "Empty Star",
      key: index,
      name: iconEmpty,
      color: color,
      size: size
    }));
  }

  return _react["default"].createElement(StyledIconList, null, icons);
});
IconList.displayName = 'IconList';
IconList.propTypes = {
  iconFull: _propTypes["default"].string,
  iconHalf: _propTypes["default"].string,
  iconEmpty: _propTypes["default"].string,
  value: _propTypes["default"].number,
  valueMax: _propTypes["default"].number,
  color: _propTypes["default"].string,
  size: _propTypes["default"].number
};
IconList.defaultProps = {
  iconFull: 'Star',
  iconHalf: 'StarHalf',
  iconEmpty: 'Star',
  value: 0,
  valueMax: 5,
  color: 'primary',
  size: 12
};
var _default = IconList;
exports["default"] = _default;